module.exports = {
  fetch: `query getStates($offset: Int, $limit: Int) {
    states(offset: $offset, limit: $limit, sortBy: "order") {
      id
      key
      name {
        en
        es
      }
      category
      type
      defaultValue
      maxValue
      possibleValues {
        key
        label {
          en
          es
        }
        picture {
          url
        }
        meta
      }
      units
    }
  }`,
  remove: `
    mutation removeStates($ids: [ID]) {
      bulkRemoveStates(ids: $ids)
    }
  `,
  add: `mutation addState($value: StateInput) {
    upsertState(state: $value) {
      id
    }
  }`,
};
